import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Chart from "../../components/chart/Chart";
import List from "../../components/table/Table";

const Single = () => {
  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="editButton">Edit</div>
            <h1 className="title">Restaurant/Hotel Information</h1>
            <div className="item">
              <img
                src="https://cdn.pixabay.com/photo/2018/07/14/15/27/cafe-3537801_1280.jpg"
                alt=""
                className="itemImg"
              />
              <div className="details">
                <h1 className="itemTitle">Zero Oil Biryani</h1>
                <div className="detailItem">
                  <span className="itemKey">Restaurant Email:</span>
                  <span className="itemValue">zero-oil@buybyeq.com</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Manger Name:</span>
                  <span className="itemValue">John Doe</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Manager Email:</span>
                  <span className="itemValue">manager@gmail.com</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Phone:</span>
                  <span className="itemValue">+1 2345 67 89</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Address:</span>
                  <span className="itemValue">
                    Garden Yd. Bhubaneswar
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Country:</span>
                  <span className="itemValue">INDIA</span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="right">
            <Chart aspect={3 / 1} title="Total Revenue ( Last 6 Months)" />
          </div> */}
        </div>
        <div className="bottom">
        <h1 className="title">Recent Orders</h1>
          <List/>
        </div>
      </div>
    </div>
  );
};

export default Single;